// extracted by mini-css-extract-plugin
export default {"thirdPartyBtnWrapper":"n7-z"};